<template>
    <div>
        <h5>Manage Themes</h5>
        <div>
            <Toolbar v-if="authStore.hasPermission(UserPermission.WRITE_THEME)" class="mb-4 card">
                <template v-slot:start>
                    <div class="my-2">
                        <Button label="Add Theme" icon="pi pi-plus" class="p-button-success mr-2" @click="dialogForm = true" />
                    </div>
                </template>
            </Toolbar>
        </div>

        <!-- create theme form -->
        <theme-form v-if="dialogForm" @hide-dialog="dialogForm = false" />

        <!-- theme table -->
        <theme-table class="card" />
    </div>
</template>

<script setup>
import ThemeForm from '../modules/ThemeForm.vue';
import ThemeTable from '../modules/ThemeTable.vue';
import { onMounted, ref } from 'vue';
import { authStore, departmentStore } from '../../../../../store/global-stores';
import { UserPermission } from '../../../../../modules/permission/enum';
const dialogForm = ref(false);

//load departments
onMounted(() => {
    departmentStore.fetchAllDepartments();
});
</script>
